export const taxTypes = [
    {code: 'income', name: 'Цена продажи'},
    {code: 'income_commission', name: 'Цена продажи с вычетом комиссии'},
    {code: 'income_commission_cost', name: 'Цена продажи с вычетом комиссии и себестоимости'},
]